import { render, staticRenderFns } from "./form-family-interview.vue?vue&type=template&id=0bd594c9&scoped=true&"
import script from "./form-family-interview.vue?vue&type=script&lang=js&"
export * from "./form-family-interview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd594c9",
  null
  
)

export default component.exports